import styled from 'styled-components'

export const QuestionFieldset = styled.fieldset`
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
`

export const QuestionLegend = styled.legend`
  width: 100%;
  margin: 0;
  padding: 0;
  color: ${p => p.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: clamp(22px, 3vw, 30px);
  font-weight: 700;
  line-height: 1.25;
`

export const OptionalLabel = styled.span`
  display: inline-flex;
  margin-left: 10px;
  color: ${p => p.theme.palette.colors.subdued};
  font-family: Lato;
  font-size: 13px;
  font-weight: 500;
  vertical-align: middle;
`

export const FieldBody = styled.div`
  margin-top: 26px;
`

export const ChoiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ScaleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(54px, 1fr));
  gap: 9px;
`

export const ScaleButton = styled.button`
  min-width: 54px;
  min-height: 48px;
  padding: 10px 14px;
  border: 1px solid ${p => p.selected ? p.theme.palette.blue.main : p.theme.palette.colors.borderSoft};
  border-radius: 12px;
  background: ${p => p.selected ? p.theme.palette.colors.badgeMuted : p.theme.palette.colors.buttonGhost};
  color: ${p => p.selected ? p.theme.palette.colors.text : p.theme.palette.colors.muted};
  font-family: Poppins;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: ${p => p.theme.palette.blue.main};
    background: ${p => p.theme.palette.colors.badgeMuted};
  }

  &:focus-visible {
    outline: 2px solid ${p => p.theme.palette.blue.main};
    outline-offset: 3px;
  }
`

export const ErrorText = styled.p`
  margin: 12px 0 0;
  color: ${p => p.theme.palette.error.main};
  font-family: Lato;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
`
